<template>
  <div>
    <router-view/>
    <v-loader v-if="showLoader" :blocking="true"/>
  </div>
</template>

<script>
import Vue from 'vue'
import VLoader from './components/Loader'

export default {
  name: 'App',
  components: {
    VLoader
  },
  data () {
    return {
      currentRequestCount: 0,
      showLoader: false
    }
  },
  created () {
    const axios = Vue.$http
    axios.interceptors.request.use((config) => {
      this.increaseRequestCount()

      return config
    }, (error) => {
      this.decreaseRequestCount()

      return Promise.reject(error)
    })

    axios.interceptors.response.use((response) => {
      this.decreaseRequestCount()

      return response
    }, (error) => {
      this.decreaseRequestCount()

      return Promise.reject(error)
    })
  },
  methods: {
    increaseRequestCount: function () {
      this.currentRequestCount++

      setTimeout(this.setShowLoader, Vue.prototype.$container.config.loaderTimeout)
    },
    decreaseRequestCount: function () {
      this.currentRequestCount--

      setTimeout(this.setShowLoader, Vue.prototype.$container.config.loaderTimeout)
    },
    setShowLoader: function () {
      this.showLoader = this.currentRequestCount > 0
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue